import type { TaskDef as OpenApiTaskDef, ExtendedTaskDef } from "../../open-api";

export const taskDefinition = ({
  name,
  ownerApp = "",
  description = "",
  retryCount = 3,
  timeoutSeconds = 3600,
  inputKeys = [],
  outputKeys = [],
  timeoutPolicy = "TIME_OUT_WF",
  retryLogic = "FIXED",
  retryDelaySeconds = 60,
  responseTimeoutSeconds = 600,
  concurrentExecLimit = 0,
  inputTemplate = {},
  rateLimitPerFrequency = 0,
  rateLimitFrequencyInSeconds = 1,
  ownerEmail = "",
  pollTimeoutSeconds = 3600,
  backoffScaleFactor = 1,
}: ExtendedTaskDef): OpenApiTaskDef =>
  ({
    name,
    ownerApp,
    description,
    retryCount,
    timeoutSeconds,
    inputKeys,
    outputKeys,
    timeoutPolicy,
    retryLogic,
    retryDelaySeconds,
    responseTimeoutSeconds,
    concurrentExecLimit,
    inputTemplate,
    rateLimitPerFrequency,
    rateLimitFrequencyInSeconds,
    ownerEmail,
    pollTimeoutSeconds,
    backoffScaleFactor,
  } as OpenApiTaskDef);
